<template>
  <div class="content-grid mdl-grid mdl-grid--no-spacing center-items">
    <!-- <div class="mdl-layout-spacer"></div> -->
      <div class="mdl-cell mdl-cell--6-col mdl-card mdl-shadow--6dp">
        <header class="mdl-card__title mdl-card--border">
          <span class="mdl-card__title-text" v-if="$store.state.userData">
              {{ `Welcome ${$store.state.userData.user.displayName}` }}
          </span>
        </header>
        <div class="mdl-cell mdl-cell--12-col mdl-card__supporting-text">
              You shall view your bill in 'All bills' menu
        </div>
      </div>
    <!-- <div class="mdl-layout-spacer"></div> -->
    <router-link id="action-button"
      class="add-picture-button mdl-button mdl-js-button mdl-button--fab mdl-button--colored mdl-shadow--16dp"
      to="/add">
      <i class="material-icons">add</i>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'login',
  data: function () {
    return {
      email: '',
      password: ''
    }
  }
}
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
#action-button {
  position: fixed;
  display: block;
  right: 0;
  bottom: 0;
  margin-right: 40px;
  margin-bottom: 40px;
  z-index: 900;
}
.mdl-grid{
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Landing.vue